import { dataAi } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAi = /*#__PURE__*/createIcon(dataAi)
export default IconAi
